import { render, staticRenderFns } from "./InvestmentsChart.vue?vue&type=template&id=6aa24f48&"
import script from "./InvestmentsChart.vue?vue&type=script&lang=ts&"
export * from "./InvestmentsChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports